import React from 'react'
import { Body, Spacer } from '@spritz-finance/ui'
import { TokenBalance } from '../../../../graphql/generated/graphql'
import styled, { css } from 'styled-components'
import { Column } from '../../../../components/Layout/Column'
import { formatCurrency, formatTokenAmount } from '../../../../utils/format'
import { useTokenPriority } from '../../../app/feature'
import TokenPlaceholder from '../../../../assets/icons/token-placeholder.png'

export const TokenImage = styled.img.attrs({
    onError: (e) => {
        // @ts-ignore
        e.currentTarget.onError = null
        e.currentTarget.src = TokenPlaceholder
    },
})`
    height: 30px;
    width: 30px;
`

export const TokenListItemWrapper = styled.div<{ isPrioritized?: boolean }>`
    padding: 0;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    height: 48px;
    ${(props) =>
        props.isPrioritized &&
        css`
            background-color: #a0e6ea40;
            margin-left: -16px;
            padding-left: 16px;
            padding-right: 16px;
            margin-right: -16px;
        `}
`

export const TokenListItem: React.VFC<{
    token: Pick<TokenBalance, 'symbol' | 'tokenImageUrl' | 'balance' | 'balanceUSD'>
}> = ({ token }) => {
    const prioritizedTokens = useTokenPriority()

    return (
        <TokenListItemWrapper isPrioritized={prioritizedTokens.includes(token.symbol)}>
            <TokenImage src={token.tokenImageUrl} />
            <Spacer width={8} />
            <div style={{ flexGrow: 1 }}>
                <Column>
                    <Body.SmBold size={14}>{token.symbol}</Body.SmBold>
                    <Body.Med size={12}>{formatTokenAmount(token.balance)}</Body.Med>
                </Column>
            </div>
            <Body.SmBold size={14}>{formatCurrency(token.balanceUSD)}</Body.SmBold>
        </TokenListItemWrapper>
    )
}
